import { Injectable, Injector } from "@angular/core";
import { Subject } from "rxjs";
import { ApiHttpService } from "../apihttp.service";
import { CPUModuleService } from "./CPUModule.service";
import { IOModuleService } from "./IOModule.service";
import { ModuleService } from "./ModuleService";
import { StorageService } from "../storage.service";
import { CurrencyPipe } from "@angular/common";
import { LockdownService } from "../lockdown.service";

export interface Cassette {
  Identifier: number;
  Denomination: number;
  IsEmpty: boolean;
  IsLow: boolean;
  IsPresent: boolean;
}

export interface BillDispenserStatus {
  Cassettes: Cassette[];
  Connected: boolean;
  DeviceFailure: boolean;
  IsBillJammed: boolean;
  IsBusy: boolean;
  LastErrorCode: string;
  LastErrorMessage: string;
  RejectBinFull: boolean;
  RejectBinNearFull: boolean;
  RejectBinPresent: boolean;
}

interface Denominations {
  [key: string]: number;
  USD_1: number;
  USD_2: number;
  USD_5: number;
  USD_10: number;
  USD_20: number;
  USD_50: number;
  USD_100: number;
  BSD_1: number;
  BSD_2: number;
  BSD_3: number;
  BSD_5: number;
  BSD_10: number;
  BSD_20: number;
  BSD_50: number;
  BSD_100: number;
}
export type ServiceStatus = Promise<
  { status: boolean, message?: string }
>
interface BillDispensedItem {
  Identifier: number;
  Denomination: 1 | 2 | 3 | 5 | 10 | 20 | 50 | 100;
  Picked: number;
  Dispensed: number;
  Rejected: number;
}

interface BillDispensedPayload {
  Fulfilled: boolean;
  Result: BillDispensedItem[];
}

interface BillDispensedEvent {
  Payload: BillDispensedPayload;
}

interface BillDispenserQueryStatusEvent {
  Payload: BillDispenserStatus;
}

const DEFAULT_CASH_METER = {
  BILL_DISPENSER_CURRENT_1: 0,
  BILL_DISPENSER_CURRENT_2: 0,
  BILL_DISPENSER_CURRENT_3: 0,
  BILL_DISPENSER_CURRENT_4: 0,
  BILL_DISPENSER_CURRENT_5: 0,
  BILL_DISPENSER_CURRENT_6: 0,
  BILL_DISPENSER_CURRENT_7: 0,
  BILL_DISPENSER_CURRENT_8: 0,

  LIFETIME_BILLS_OUT_1: 0,
  LIFETIME_BILLS_OUT_2: 0,
  LIFETIME_BILLS_OUT_5: 0,
  LIFETIME_BILLS_OUT_10: 0,
  LIFETIME_BILLS_OUT_20: 0,
  LIFETIME_BILLS_OUT_50: 0,
  LIFETIME_BILLS_OUT_100: 0,

  BILL_REJECTBIN_1: 0,
  BILL_REJECTBIN_2: 0,
  BILL_REJECTBIN_5: 0,
  BILL_REJECTBIN_10: 0,
  BILL_REJECTBIN_20: 0,
  BILL_REJECTBIN_50: 0,
  BILL_REJECTBIN_100: 0,

  SVC_BILL_DISPENSER_OUT_1: 0,
  SVC_BILL_DISPENSER_OUT_2: 0,
  SVC_BILL_DISPENSER_OUT_3: 1,
  SVC_BILL_DISPENSER_OUT_4: 0,
  SVC_BILL_DISPENSER_OUT_5: 0,
  SVC_BILL_DISPENSER_OUT_6: 0,
  SVC_BILL_DISPENSER_OUT_7: 0,
  SVC_BILL_DISPENSER_OUT_8: 0
}

@Injectable({
  providedIn: 'root'
})
export class BillDispenserService extends ModuleService {
  //BillDispenser
  public status: BillDispenserStatus = {
    Cassettes: [],
    Connected: false,
    DeviceFailure: false,
    IsBillJammed: false,
    IsBusy: false,
    LastErrorCode: "",
    LastErrorMessage: "",
    RejectBinFull: false,
    RejectBinNearFull: false,
    RejectBinPresent: false,
  }

  public tx_denominations: Denominations = {
    "USD_1": 0,
    "USD_2": 0,
    "USD_5": 0,
    "USD_10": 0,
    "USD_20": 0,
    "USD_50": 0,
    "USD_100": 0,
    "BSD_1": 0,
    "BSD_2": 0,
    "BSD_3": 0,
    "BSD_5": 0,
    "BSD_10": 0,
    "BSD_20": 0,
    "BSD_50": 0,
    "BSD_100": 0,
  };
  queryStatus: { callers: any[], has_pending: boolean } = {
    has_pending: false,
    callers: []
  }
  userPresent: any;

  constructor(private io_module: IOModuleService, public injector: Injector, public http: ApiHttpService, public cpu: CPUModuleService, public storage: StorageService, public currencypipe: CurrencyPipe, public lockdownService: LockdownService) {
    super("Bill_Dispenser", injector)
    this.logger.log('Bill_Dispenser constructor')
    this.connection$.subscribe(async (connected) => {
      // this.callMethod('BillDispenser_SetSnapshotCashMeters').then((response: any) => {
      // }).catch(this.logger.log)
      // this.callMethod('BillDispenser_GetCashMeters').then((response: any) => {
      // }).catch(this.logger.log)
      // this.status = await this.getLatestStatus()
    })
    this.on('OnBillDispenserConnected_Event', async () => {
      this.resetOnFreshReboot()
      this.status = await this.getLatestStatus()
    })

    this.on('OnBillDispenserDispensed_Event', async () => {
      this.signalR.log('AppLog_Info', { message: "track meters" })
      let meters = await this.getCashMeters()
      let user = this.storage.get('user')
      this.getLatestStatus().then(async (status) => {
        this.http.post(this.config.API_SAVE_METER_OUT, { session: user.SessionID, terminal_id: user.TerminalId, meters: JSON.stringify(meters), cassettes: JSON.stringify(status.Cassettes) })
        if (status.DeviceFailure) {
          this.cpu.getComputerData().then((cpuInfo) => {
            this.http.notifyAdmin([cpuInfo.KioskName, this.DeviceManagerInterface, 'DEVICE_FAILURE'].join(':'),
              JSON.stringify({
                LEVEL: 'PRIO_HIGH',
                cpuInfo,
                meters
              }))
          })
        }
        if (status.IsBillJammed) {
          this.cpu.getComputerData().then((cpuInfo) => {
            this.http.notifyAdmin([cpuInfo.KioskName, this.DeviceManagerInterface, 'BILL_JAMMED'].join(':'),
              JSON.stringify({
                LEVEL: 'PRIO_HIGH',
                cpuInfo,
                meters
              }))
          })
        }
        status.Cassettes.map(async (cassette) => {
          if (cassette.IsLow) {
            this.cpu.getComputerData().then((cpuInfo) => {
              this.http.notifyAdmin([cpuInfo.KioskName, this.DeviceManagerInterface, 'BIN_LOW'].join(':'),
                JSON.stringify({
                  LEVEL: 'PRIO_LOW',
                  cassette,
                  cpuInfo,
                  meters
                })
              )
            })
          }
          if (cassette.IsEmpty) {
            this.cpu.getComputerData().then((cpuInfo) => {
              this.http.notifyAdmin([cpuInfo.KioskName, this.DeviceManagerInterface, 'BIN_EMPTY'].join(':'),
                JSON.stringify({
                  LEVEL: 'PRIO_MEDIUM',
                  cassette,
                  cpuInfo,
                  meters
                }))
            })
          }
        })
      })
    })
  }

  /**
   *
   * @deprecated no sense of using, just use getLatestStatus
   * @returns last cached status
   */
  public getStatus(): Promise<BillDispenserStatus> {
    return new Promise((resolve, reject) => {
      if (!this.status.Connected) {
        this.callMethod('BillDispenser_GetDeviceStatus')
          .then((response: BillDispenserStatus) => {
            resolve(response)
          }).catch((er) => {
            resolve(this.status)
          })
      } else {
        resolve(this.status)
      }
    })
  }

  public getLatestStatus(): Promise<BillDispenserStatus> {
    return new Promise((resolve, reject) => {
      if (!this.status.Connected) {
        this.queryStatus.callers.push(resolve)
        if (!this.queryStatus.has_pending) {
          this.queryStatus.has_pending = true
          this.once('onBillDispenserQueryStatus_Event', (response: BillDispenserQueryStatusEvent) => {
            this.queryStatus.has_pending = false
            this.queryStatus.callers.forEach((cb) => {
              cb(response.Payload)
            })
            this.queryStatus.callers = []
          })

          this.billDispenser_QueryStatus()
            .then((_) => {
            }).catch((er) => {
              this.queryStatus.has_pending = false
              this.queryStatus.callers.forEach((cb) => {
                cb(this.status)
              })
              this.queryStatus.callers = []
              // resolve(this.status)
            })
        }
      } else {
        resolve(this.status)
      }
    })
  }

  public isAvailable(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      resolve(!this.config.KIOSK_ENABLED || (this.connected && !this.status.DeviceFailure && !this.status.Cassettes.map(cassette => cassette.IsEmpty).reduce((result, item) => result && item, true)))
    })
  }

  public getLowestDenomination(): Promise<number> {
    let lowest_denomination = 0;
    return new Promise(async (resolve, reject) => {
      let status = await this.getLatestStatus()
      status.Cassettes.map((cassette) => {
        if ((((cassette.Denomination < lowest_denomination) || !lowest_denomination) && (!cassette.IsEmpty && cassette.IsPresent))) {
          lowest_denomination = cassette.Denomination
        }
      })
      resolve(lowest_denomination);
    })
  }

  public billDispenser_Connect() {
    return this.callMethod("billDispenser_Connect");
  }

  public billDispenser_IsConnected() {
    return this.callMethod("billDispenser_IsConnected");
  }

  public billDispenser_LockCassettes() {
    return this.callMethod("billDispenser_LockCassettes");
  }

  public billDispenser_UnlockCassettes() {
    return this.callMethod("billDispenser_UnlockCassettes");
  }

  public billDispenser_Reset(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.callMethod("billDispenser_Reset").then((canReset) => {
        if (canReset) {
          this.once('onBillDispenserResetComplete_Event', (response: any) => (
            resolve(true)
          ))
        }
        return resolve(canReset)
      })
    });
  }

  public turnOffModule() {
    return this.module(false)
  }

  public billDispenser_DispenseBills(amount: any): Promise<void> {
    this.module(true)
    this.once('OnBillDispenserDispensed_Event', this.turnOffModule.bind(this))

    if (this.config.KIOSK_ENABLED) {
      return this.callMethod("billDispenser_DispenseBills", amount);
    } else {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          this.fakeTrigger('OnBillDispenserDispensed_Event', {
            Payload: {
              "Fulfilled": true,
              "Result": [
                {
                  "Identifier": 1,
                  "Denomination": 1,
                  "Picked": amount,
                  "Dispensed": amount,
                  "Rejected": 0
                },
              ],
              "AmountDispensed": amount
            }
          })
        }, 0);
        resolve()
      })
    }
  }

  public BillDispenser_DispenseByIdentifier(identifier: any, qty: any) {
    return this.callMethod("BillDispenser_DispenseByIdentifier", identifier, qty);
  }

  /**
   *
   * @returns latest status
   */
  public billDispenser_QueryStatus() {
    return this.callMethod("billDispenser_QueryStatus");
  }

  /**
   *
   * @returns
   * @deprecated
   */
  public billDispenser_GetCashMeters(): Promise<any> {
    // let v = {
    //   "SVC_BILL_DISPENSER_OUT_1": 25,
    //   "BILL_DISPENSER_CURRENT_1": -25,
    //   "LIFETIME_BILLS_OUT_1": 25,
    //   "SVC_BILL_DISPENSER_OUT_2": 4,
    //   "BILL_DISPENSER_CURRENT_2": -4,
    //   "LIFETIME_BILLS_OUT_10": 4,
    //   "SVC_BILL_DISPENSER_OUT_3": 1,
    //   "BILL_DISPENSER_CURRENT_3": -1,
    //   "LIFETIME_BILLS_OUT_50": 1
    // }
    // return new Promise((resolve, reject) => {
    //   resolve(v)
    // })
    return this.callMethod("billDispenser_GetCashMeters");
  }

  public getCashMeters(): Promise<typeof DEFAULT_CASH_METER> {
    return this.callMethod("billDispenser_GetCashMeters").catch((error) => {
      this.signalR.log('AppLog_Error', {
        message: "billDispenser_GetCashMeters",
        metadata: {
          error,
        }
      })
      return DEFAULT_CASH_METER;
    })
  }

  public clearCashMeters() {
    return this.callMethod("BillDispenser_ResetCurrentCashMeters")
  }

  public billDispenser_GetCurrentCashMeterIndicators() {
    return this.callMethod("billDispenser_GetCurrentCashMeterIndicators");
  }

  public billDispenser_ProcOverride() {
    return this.callMethod("billDispenser_ProcOverride");
  }

  public billDispenser_Disconnect() {
    return this.callMethod("billDispenser_Disconnect");
  }

  public module(toggle: boolean) {
    this.io_module.turnOutputDevice(toggle, 4).then((r) => {
      this.logger.log('turned ' + (toggle ? 'on' : 'off') + ' module 4')
    }).catch((e) => {
      this.logger.log('Failed to turn Module 4 ' + (toggle ? 'on' : 'off'))
      this.logger.log(e)
    })
    this.io_module.turnOutputDevice(toggle, 5).then((r) => {
      this.logger.log('turned ' + (toggle ? 'on' : 'off') + ' module 5')
    }).catch((e) => {
      this.logger.log('Failed to turn Module 5 ' + (toggle ? 'on' : 'off'))
      this.logger.log(e)
    })
  }


  public trackDenominations(event: BillDispensedEvent) {
    let bill: BillDispensedPayload = event.Payload
    bill.Result.map((item) => {
      let currency = "USD"; // no currency identifier for cassette
      let key = [currency, item.Denomination].join('_');
      this.tx_denominations[key] += item.Picked;
    })
    let timestamp = +new Date
    this.http.kioskLog({
      type: 'event',
      name: 'onBillDispenserDispensed_Event',
      event,
      timestamp
    })
  }

  public onDispensed(): Promise<BillDispensedEvent> {
    return new Promise((resolve, reject) => {
      this.once('onBillDispenserDispensed_Event', (event: BillDispensedEvent) => {
        this.trackDenominations(event)
        resolve(event)
      })
    })
  }

  public getTxDenominations(): Promise<Denominations> {
    return new Promise((resolve, reject) => {
      resolve(this.tx_denominations);
    })
  }

  async dispensable(amount: number, multiples: number[] = []) {
    if (multiples.length == 0) {
      let status = await this.getLatestStatus()
      status.Cassettes.map((cassette) => {
        if (!cassette.IsEmpty && cassette.IsPresent) {
          multiples.push(cassette.Denomination)
        }
      })
    }
    multiples.sort((a, b) => b - a)
    let change = amount
    // let log: { [k: number]: number } = {}
    multiples.forEach(multiple => {
      if (change > 0) {
        while (change >= multiple) {
          change -= multiple
          // if (!log[multiple]) {
          //   log[multiple] = 0
          // }
          // log[multiple] += 1;
        }
      }
    })
    // console.log(log)
    return change == 0
  }

  async computeDispensable(amount: number) {
    let change = amount;
    let status = await this.getLatestStatus()
    let denominations: number[] = [];
    let meters = await this.getCashMeters()
    let identifiers: any = {}
    status.Cassettes.forEach((cassette: Cassette) => {
      if (!cassette.IsEmpty && cassette.IsPresent) {
        denominations.push(Number(cassette.Denomination))
        identifiers[cassette.Denomination] = cassette.Identifier
      }
    })

    denominations.sort((a, b) => b - a)
    let dispensable = 0;
    let emptyMeter = true
    denominations.forEach((denomination) => {
      let meter = (<any>meters)['BILL_DISPENSER_CURRENT_' + identifiers[denomination]] || 0
      emptyMeter = emptyMeter && meter == 0
      while (change >= denomination && meter >= 1) {
        change -= denomination
        dispensable += denomination
        meter -= 1;
      }
    })
    return [dispensable, change];
  }

  async resetOnFreshReboot(lastUpTime?: number): Promise<void> {
    let lastDispenserReset = this.storage.get('lastDispenserReset', 0)
    let uptimeMS = lastUpTime || (await this.cpu.callMethod('CPU_GetSystemUpTimeMS')) as number;
    let now = Date.now();
    let needsReset = this.DeviceManagerInterface == "BillDispenser.Fujitsu.F53" && (
      !lastDispenserReset ||
      (lastDispenserReset < (now - uptimeMS))
    )

    if (needsReset) {
      return this.billDispenser_Reset()
        .then((response) => {
          if (response) {
            this.storage.set('lastDispenserReset', Date.now())
            return Promise.resolve()
          } else {
            return (new Promise<void>((resolve, _reject) => {
              setTimeout(() => {
                resolve()
              }, 1000 * 5);
            })).then(() => {
              return this.resetOnFreshReboot(uptimeMS)
            })
          }
        })
    }
    return Promise.resolve()
  }

  public async canDispense(amount: number = 0): ServiceStatus {
    let status = await this.getLatestStatus()
    let denominations: number[] = [];
    let meters = await this.getCashMeters()
    let identifiers: any = {}
    status.Cassettes.forEach((cassette: Cassette) => {
      if (!cassette.IsEmpty && cassette.IsPresent) {
        denominations.push(Number(cassette.Denomination))
        identifiers[cassette.Denomination] = cassette.Identifier
      }
    })

    denominations.sort((a, b) => b - a)
    this.signalR.log('AppLog_Info', {
      message: "canDispense start",
      metadata: {
        amount,
        identifiers,
        status,
        denominations
      }
    })
    let dispensable = 0;
    let emptyMeter = true
    denominations.forEach((denomination) => {
      let meter = (<any>meters)['BILL_DISPENSER_CURRENT_' + identifiers[denomination]] || 0
      emptyMeter = emptyMeter && meter == 0

      this.signalR.log('AppLog_Info', {
        message: "canDispense " + denomination,
        metadata: {
          meter,
          amount,
          dispensable,
          denomination
        }
      })
      while (amount >= denomination && meter >= 1) {
        amount -= denomination
        dispensable += denomination
        meter -= 1;

        this.signalR.log('AppLog_Info', {
          message: "canDispense",
          metadata: {
            meter,
            amount,
            dispensable,
            denomination
          }
        })
      }
    })
    const logError = (error: { message: string, status: boolean }) => {
      this.signalR.log("AppLog_Info", { message: error.message });
      return error;
    };

    if (emptyMeter) {
      return Promise.resolve(logError({
        status: false,
        message: 'Cash meters are empty'
      }))
    }
    if (amount > 0) {
      return Promise.resolve(logError({
        status: false,
        message: 'No denomination available to fulfill the amount. Max dispensable is ' + dispensable
      }))
    }
    if (!this.connected) {
      return Promise.resolve(logError({
        status: false,
        message: 'Not connected'
      }))
    }
    if (status.IsBillJammed) {
      return Promise.resolve(logError({
        status: false,
        message: 'Bill is jammed'
      }))
    }
    if (status.DeviceFailure) {
      return Promise.resolve(logError({
        status: false,
        message: 'Device failure'
      }))
    }

    return Promise.resolve({ status: true })
  }


  dispenseBill(amount: number): Promise<{ amountLeft: number }> {
    this.userPresent = setInterval(() => {
      this.lockdownService.setUserPresent()
    }, 1000);
    this.signalR.log('AppLog_Info', { message: 'SetUserPresent interval called' })
    return new Promise((resolve, reject) => {
      // try {
      //   this.signalR.connect().then(() => {
      //     this.signalR.getComponent(this.billDispenser).then((c: any) => {
      let amountLeft = Number(amount)
      this.once('OnBillDispenserDispensed_Event', (event: any) => {
        let payload = event.Payload;
        amountLeft -= Number(payload.AmountDispensed)
        clearInterval(this.userPresent)
        this.signalR.log('AppLog_Info', { message: 'SetUserPresent interval cleared' })
        if (payload.Fulfilled || payload.AmountDispensed > 0) {
          resolve({ amountLeft })
        } else {
          // let dispensed = { picked: 0, amount: 0 };
          // payload.Result.map((item: { Identifier: number, Denomination: number, Picked: number, Dispensed: number, Rejected: number }) => {
          //   dispensed.amount += (item.Denomination * item.Dispensed)
          //   dispensed.picked += (item.Denomination * item.Picked)
          // })
          reject({ code: "1000", message: "Failed to dispense " + this.currencypipe.transform(amountLeft) })
        }
      })
      this.billDispenser_DispenseBills(amount).catch((error) => {
        if (error && error.bypass) {
          resolve({ amountLeft })
        } else {
          reject({ code: "1000", message: "Failed to dispense " + this.currencypipe.transform(amountLeft) })
        }
      })
      //     }).catch((e) => {
      //       reject({ code: "1000", message: "Unavailable to withdraw" })
      //     })
      //   }).then((e) => {
      //     this.logger.log(e)
      //   }).catch(() => {
      //     reject({ code: "1000", message: "Unavailable to withdraw" })
      //   })
      // }
      // catch (e) {
      //   reject({ code: "1000", message: "Unavailable to withdraw" })
      //   this.logger.log(e)
      // }
    })
  }

  usedTobeReset() {
    // TODO: temp Fplaceholder
    return Promise.resolve()
  }
}
